import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation(); // بيراقب المسار الحالي

    useEffect(() => {
        // أول ما المسار يتغير، بيطلع المتصفح لأعلى نقطة (0, 0) بنعومة
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant" // ممكن تخليها "smooth" لو عايز طلوع ناعم
        });
    }, [pathname]);

    return null; // المكون ده مش بيعرض أي حاجة على الشاشة
}